import { Environment } from "@omni/types/enums/environment.enum";
import { FeatureToggleKey } from "@omni/types/enums/featureToggleKey.enum";
import { cn } from "@omni/utils/styles";

import { useFeatureToggle } from "@/context/featureToggles.context";
import { Config } from "@/utils/config.utils";

import { Placement } from "./components/placement";

const KLARNA_ENVIRONMENT_PLAYGROUND = "playground";
const KLARNA_ENVIRONMENT_PRODUCTION = "production";

type Props = {
    amount: number;
};

export const KlarnaOsm = ({ amount }: Props) => {
    const klarnaOsmEnabled = useFeatureToggle(
        FeatureToggleKey.FEATURE_KLARNA_OSM
    );

    const klarnaClientId = Config.integrations["klarna-client-id"];
    const klarnaClientSrc = Config.integrations["klarna-client-src"];

    // Klarna expects the standard locale formate (e.g. en-US)
    const locale = Config.getLanguageTag();

    const environmentAttribute =
        Config.general.environment !== Environment.Prod
            ? KLARNA_ENVIRONMENT_PLAYGROUND
            : KLARNA_ENVIRONMENT_PRODUCTION;

    // Klarna expects the amount in cents
    const amountInCents = Math.round(amount * 100).toString();

    if (!klarnaOsmEnabled || !klarnaClientId || !klarnaClientSrc) return null;

    return (
        <div className={cn("tw:mt-2")}>
            <Placement
                amount={amountInCents}
                klarnaClientId={klarnaClientId}
                klarnaClientSrc={klarnaClientSrc}
                environmentAttribute={environmentAttribute}
                locale={locale}
            />
        </div>
    );
};
